module.exports = __webpack_public_path__ + "static/logo-details-4baa113da95701258badad4a53f9c017.png";